import IconButton from '@mui/material/IconButton'
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined'

interface ButtonProps {
  onClick: () => void
  title?: string
  children?: React.ReactNode
  dataTestId?: string
}

export const ViewButton: React.FC<ButtonProps> = ({ onClick, title = 'View item', children, dataTestId }) => (
  <Tooltip title={title}>
    <IconButton
      data-testid={dataTestId}
      onClick={onClick}
    >
      {children || <VisibilityOutlined className='icon-pantoneBlue' />}
    </IconButton>
  </Tooltip>
)
